import React from 'react';
import { RouteObject } from 'react-router-dom';
import AppLayout from '@pages/_layout/AppLayout';
import { TechnicalWorks } from '@pages/PageError';

export default [
  {
    path: '/wind',
    element: <AppLayout />,
    children: [{ index: true, element: <TechnicalWorks /> }],
  },
] as RouteObject[];
